module.exports = __webpack_public_path__ + "img/search-temp.cecf78ee.png";